
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/luma-scientific-intelligence-platform",
      function () {
        return require("private-next-pages/luma-scientific-intelligence-platform/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/luma-scientific-intelligence-platform"])
      });
    }
  